import React, { useEffect, useContext, useState} from 'react'
import { StateController } from '../../App'
import VerticalCenter from '../../layouts/VerticalCenter/VerticalCenter'
import Icon from '../atoms/Icon'
import Preloader from '../atoms/Preloader'

function TCModal({
  show,
  setShowModal
}) {
  const { setMdalOpen } = useContext(StateController)
  const { staticContent } = useContext(StateController)
  const [termsHTML, setTermsHTML] = useState(false)

  useEffect(() => {
    setMdalOpen(show);
    
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  useEffect(() => {
    if (staticContent && staticContent.terms && staticContent.terms[0].content) {
      setTermsHTML(staticContent.terms[0].content)
    }
  }, [staticContent])

  const close = () => {
    setShowModal(false)
  }

  return (
    <div className={`mc-tc-modal ${show && 'mc-tc-modal__opened'} slow_ani`}>
      <div className="mc-tc-modal__overlay slow_ani" onClick={close}></div>
      <div className="mc-tc-modal__center">
        <VerticalCenter>
          <div className="mc-tc-modal__close" onClick={close}>
            <Icon name="close" />
          </div>
          <div className={`mc-tc-modal__center--window slow_ani`}>
            <img src='/assets/images/confeti_mechanic_modal.png' className='confeti_izq' alt='confeti_izq'/>
            <div>
              <div className={`mc-tc-modal__center--window__title`}>
                <p>Términos y condiciones</p>
              </div>
              <div className={`mc-tc-modal__center--window__subtitle`}>
                <p>Campaña: Compra y Gana tus Recompensas</p>
              </div>
              {termsHTML
                ? <div className='mc-static-content'>
                    <div dangerouslySetInnerHTML={{ __html: termsHTML }} />
                  </div>
                : <Preloader
                    type="section"
                  />
              }
            </div>
          </div>
        </VerticalCenter>
      </div>
    </div>
  )
}

export default TCModal